var t = /* @__PURE__ */ ((r) => (r.NEXT = "next", r.PREV = "prev", r))(t || {}), e = /* @__PURE__ */ ((r) => (r.CURSOR = "cursor", r.OFFSET = "offset", r))(e || {});
export {
  t as PageNeighbour,
  e as PaginationType
};
